function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  d: "M5 16c0 .876-1.124 2-2 2-1.876 0-3-1.124-3-2 0-1.876 1.124-3 3-3h2v3zm1-1c0-.902 1.124-2 3-2 .876 0 2 1.098 2 2v7c0 .902-1.124 2-2 2-1.876 0-3-1.098-3-2v-7z",
  fill: "#E01E5A"
}), React.createElement("path", {
  d: "M9 5C7.124 5 6 3.876 6 3c0-1.876 1.124-3 3-3 .876 0 2 1.124 2 2v3H9zm0 1c.902 0 2 1.124 2 3 0 .876-1.098 2-2 2H2c-.902 0-2-1.124-2-3 0-.876 1.098-2 2-2h7z",
  fill: "#36C5F1"
}), React.createElement("path", {
  d: "M19 9c0-1.876 1.124-3 3-3 .876 0 2 1.124 2 3 0 .876-1.124 2-2 2h-3V8v1zm-1 0c0 .902-1.124 2-2 2-1.876 0-3-1.098-3-2V2c0-.902 1.124-2 3-2 .876 0 2 1.098 2 2v7z",
  fill: "#2EB67C"
}), React.createElement("path", {
  d: "M16 19c.876 0 2 1.124 2 3 0 .876-1.124 2-2 2-1.876 0-3-1.124-3-2v-3h3zm-1-1c-.902 0-2-1.124-2-2 0-1.876 1.098-3 2-3h7c.902 0 2 1.124 2 3 0 .876-1.098 2-2 2h-7z",
  fill: "#ECB22D"
}));

var SvgSlack = function SvgSlack(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgSlack;